export default "__VITE_ASSET__TShuUl4o__"